// dashbaord
import Default from "../Components/Dashboard/Default";
import Ecommerce from "../Components/Dashboard/Ecommerce";

//widgets
import Chart from "../Components/Widgets/Chart";
import General from "../Components/Widgets/General";



//Masters

import FilterCategoryListing from "../Modules/Masters/filter category List/Filtercategory";
import AddFilterCategory from "../Modules/Masters/filter category List/Add";
import EditFilterCategory from "../Modules/Masters/filter category List/Edit";
import ViewFilterCategory from "../Modules/Masters/filter category List/View";
import DeletedFilterCategory from "../Modules/Masters/filter category List/DeletedFilterCategory";
import CategoryListing from "../Modules/Masters/category List/category";
import AddCategory from "../Modules/Masters/category List/Add";
// import ChargerTypeListing from "../Modules/Masters/Charger Type/ChargerType";
// import ChargerTypeListingAdd from "../Modules/Masters/Charger Type/Add";
// import Connector from "../Modules/Masters/Connector/Connector";
// import AddConnector from "../Modules/Masters/Connector/Add";


//Offers

import OfferListing from "../Modules/Offers/RFID Offers/RfidOffers";
import AddOffers from "../Modules/Offers/RFID Offers/Add";
import EditOffers from "../Modules/Offers/RFID Offers/Edit";
import ViewOffers from "../Modules/Offers/RFID Offers/View";


//charts
import LineChartApex from "../Modules/charts/charts";

//users

import UserListing from "../Modules/Users/Users";
import EditUser from "../Modules/Users/Edit";
import ViewUser from "../Modules/Users/View";
import AddUser from "../Modules/Users/Add";
import DeletedUserRequest from "../Modules/Users/Users_Deleted_Request";
import DeletedUsers from "../Modules/Users/DeletedUsers";
import Vendors from "../Modules/Users/Vendors";
import AddVendor from "../Modules/Users/AddVendor";
import EditVendor from "../Modules/Users/EditVendor";


//stations

import Stations from "../Modules/Stations/Stations";
import AddStations from "../Modules/Stations/Add";
import EditStation from "../Modules/Stations/Edit";
import ViewStation from "../Modules/Stations/View";
import ChargerLivestatus from "../Modules/Stations/ChargerLiveStatus";
import AssignCharger from "../Modules/Stations/AssignCharger";
import DeletedStations from "../Modules/Stations/DeletedStations";
import Chargerstatuscrosscheck from "../Modules/Stations/Crosscheckwithoutdata";
import DummyImage from "../Modules/Stations/Dummyimage";

//chargers

import ChargerListing from "../Modules/Chargers/ChargerListing";
import AddCharger from "../Modules/Chargers/Add";
import EditCharger from "../Modules/Chargers/Edit";
import ViewCharger from "../Modules/Chargers/View";
import DeletedChargers from "../Modules/Chargers/DeletedChargers";
import UploadDummyImage from "../Modules/Chargers/Dummyimage";

//connectors

import ConnectorListing from "../Modules/Chargers/connectors";

//ocpp

import OcppListing from "../Modules/ocpp/ocppListing";



import LivePing from "../Modules/ocpp/LivePing";


//rfid
import RfidListing from "../Modules/Rfid Record/RfidListing";
import AddRfidOffer from "../Modules/Rfid Record/Add";
import EditRfid from "../Modules/Rfid Record/Edit";
import ViewRfid from "../Modules/Rfid Record/View";
import RfidOffers from "../Modules/Rfid Record/RfidOffer";
import QrcodePayment from "../Modules/Rfid Record/QrCodePayments";

//Meters
import MeterListing from "../Modules/Meters/Meter";
import EditMeter from "../Modules/Meters/Edit";
import ViewMeter from "../Modules/Meters/View";
import UserTransactionRequest from "../Modules/Meters/Userrequest";
import ChargerExtraValues from "../Modules/Meters/AwaitingStartChargers";

//statements
import StatementListing from "../Modules/Statements/Statements";

import BankAccountsListing from "../Modules/BankAccounts/BankAccountListing";
import BankAccountsAdd from "../Modules/BankAccounts/Add";
import BankAccountsEdit from "../Modules/BankAccounts/Edit";


//evtor

import EvtorListing from "../Modules/Evtor/Evtor";
import LiveData from "../Modules/Evtor/LiveData";
// import StationDiv from "../Modules/Stations/EvtorDiv";
import KWPowerDifference from "../Modules/Evtor/KWPowerDiff";

//Payments

import Payments from "../Modules/Payments/Payments";
import Withdrawl from "../Modules/Payments/Withdrawl";
import EvtorDataAnalysis from "../Modules/Payments/EvtorDataAnalysis";
import QRCodePayments from "../Modules/Payments/QrCodePayments";

//excel-report
 import ReportDataExcel from "../Modules/ReportExcel/ReportDataExcel";

 //sms-logs
 import SMSLogs from "../Modules/SMSLogs/SMSLogs";

 //Profile-Page
 import ProfilePage from "../Modules/Settings/ProfilePage";

 //Versions
 import VersionsListing from "../Modules/Versions/VersionsListing";
 import EditVersions from "../Modules/Versions/Edit";
 import Testing from "../Modules/Versions/Testing";


export const routes = [
  //dashboard
  {
    path: `${process.env.PUBLIC_URL}/dashboard/default`,
    Component: <Default />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,
    Component: <Ecommerce />,
  },

  // //widgets
  { path: `${process.env.PUBLIC_URL}/widgets/general`, Component: <General /> },
  { path: `${process.env.PUBLIC_URL}/widgets/chart`, Component: <Chart /> },
  

 

//Masters

  {
    path: `/masters/filtercategorylist`,
    Component: <FilterCategoryListing />,
  },
  {
    path: `/masters/filtercategorylist/:pid`,
    Component: <FilterCategoryListing />,
  },
  {
    path: `/masters/filtercategorylist/add`,
    Component: <AddFilterCategory />,
  },
  {
    path: `/masters/filtercategorylist/add/:pid`,
    Component: <AddFilterCategory />,
  },
  {
    path: `/masters/filtercategorylist/edit/:cid`,
    Component: <EditFilterCategory />,
  },
  {
    path: `/masters/filtercategorylist/view/:zid`,
    Component: <ViewFilterCategory />,
  },
  
  {
    path: `/masters/categorylist`,
    Component: <CategoryListing />,
  },
  {
    path: `/masters/categorylist/add`,
    Component: <AddCategory />,
  },
  {
    path: `/masters/deletedfiltercategorylist`,
    Component: <DeletedFilterCategory />,
  },

//Offers

{
  path: `/offers/offer-list`,
  Component: <OfferListing />,
},
{
  path: `/offers/add-Offer`,
  Component: <AddOffers />,
},
{
  path: `/offers/edit-Offer/:wid`,
  Component: <EditOffers />,
},
{
  path: `/offers/view-Offer/:wid`,
  Component: <ViewOffers />,
},
  
 

  //stations

  {
    path: `/stations`,
    Component: <Stations />,
  },
  {
    path: `/assigncharger/:qid`,
    Component: <AssignCharger />,
  },
  
  {
    path: `/stations/add`,
    Component: <AddStations />,
  },
  {
    path: `/stations/edit/:cid`,
    Component: <EditStation />,
  },
  {
    path: `/stations/view/:wid`,
    Component: <ViewStation />,
  },

  {
    path: `/charger-live-status`,
    Component: <ChargerLivestatus/>,
  },
  {
    path: `/charger-live-status-cross-check`,
    Component: <Chargerstatuscrosscheck/>,
  },
  //
  {
    path: `/deleted-stations`,
    Component: <DeletedStations/>,
  },
  {
    path: `/stations-upload-dummyImage`,
    Component: <DummyImage/>,
  },
  //DummyImage

  //charts
  {
    path: `/charts`,
    Component: <LineChartApex/>,
  },
  
  //Users

  {
    path: `/usermanagement/users`,
    Component: <UserListing />,
  },
  {
    path: `/usermanagement/vendors`,
    Component: <Vendors />,
  },

  {
    path: `/usermanagement/users/edit/:uid`,
    Component: <EditUser/>,
  },
  {
    path: `/usermanagement/users/view/:uid`,
    Component: <ViewUser/>,
  },
  { path: "/usermanagement/users/requestdeletedusers", Component: <DeletedUserRequest /> },
  { path: "/usermanagement/users/add", Component: <AddUser /> },
  { path: "/usermanagement/vendors/add", Component: <AddVendor /> },
  { path: "/usermanagement/vendors/edit/:wid", Component: <EditVendor /> },
  //
  { path: "/usermanagement/users/deletedusers", Component: <DeletedUsers /> },

  //chargers

  {
    path: `/chargers`,
    Component: <ChargerListing />,
  },
  {
    path: `/chargers/deletedchargers`,
    Component: <DeletedChargers />,
  },
  {
    path: `/chargers/:nid`,
    Component: <ChargerListing />,
  },
  {
    path: `/chargers/edit/:cid`,
    Component: <EditCharger/>,
  },
  {
    path: `/chargers/view/:cid`,
    Component: <ViewCharger/>,
  },
  { path: "/chargers/add/:qid", Component: <AddCharger/> },
  { path: "/connectors", Component: <ConnectorListing/> },
  
  { path: "/charger-upload-dummyImage", Component: <UploadDummyImage/> },
  //ocpp-model
  
  { path: "/ocpp/ocpp-logs", Component: <OcppListing/> },
  { path: "/ocpp-logs/liveping", Component: <LivePing/> },
  

  //rfid-Record
  { path: "/rfid-record/rfid-list", Component: <RfidListing/> },
  { path: "/rfid-record/rfid-list/:fid", Component: <RfidListing/> },
  { path: "/rfid-record/rfidoffer-add", Component: <AddRfidOffer/> },
  { path: "/rfid-record/rfid-edit/:rid", Component: <EditRfid/> },
  { path: "/rfid-record/rfid-view/:rid", Component: <ViewRfid/> },
  { path: "/rfid-record/rfid-offers", Component: <RfidOffers/> },
  { path: "/rfid-record/qrcode-payment", Component: <QrcodePayment/> },

  //Meter

{ path: "/meter-record/meter-list", Component: <MeterListing/> },
{ path: "/meter-record/meter-list/:mid", Component: <MeterListing/> },
{ path: "/meter-record/meter-list/edit/:tid", Component: <EditMeter/> },
{ path: "/meter-record/meter-list/view/:tid", Component: <ViewMeter/> },
{ path: "/meter-record/user-transaction-request", Component: <UserTransactionRequest/> },
{ path: "/meter-record/awaitingstartchargers", Component: <ChargerExtraValues/> },
{ path: "/statements/statementListing", Component: <StatementListing/> },
{ path: "/statements/statementListing/:cid", Component: <StatementListing/> },

//evtorListing
{ path: "/evtor/evtorListing", Component: <EvtorListing/> },
{ path: "/evtor-logs/livedata", Component: <LiveData/> },
{ path: "/evtor-logs/kwpowerdifference", Component: <KWPowerDifference/> },


//Payments
{ path: "/payments", Component: <Payments/> },
{ path: "/withdrawals", Component: <Withdrawl/> },
{ path: "/evtordataanalysis", Component: <EvtorDataAnalysis/> },
{ path: "/qrcodepayments", Component: <QRCodePayments/> },

//report-excel
{ path: "/report-excel", Component: <ReportDataExcel/> },

//SMSLogs
{ path: "/sms-logs", Component: <SMSLogs/> },
{ path : "/profile-page", Component: <ProfilePage/>},

//Versions

{ path : "/versions", Component: <VersionsListing/>},
{ path : "/versions/edit/:wid", Component: <EditVersions/>},
{ path : "/testing", Component: <Testing/>},
//Bank Accounts
{ path: "/bank-accounts/bank-account-listing/:user_id", Component: <BankAccountsListing/> },
{ path: "/bank-accounts/bank-account-add/:user_id", Component: <BankAccountsAdd/> },
{ path: "/bank-accounts/bank-account-edit/:user_id/:bank_id", Component: <BankAccountsEdit/> },

];
